window.GiftBox = {customIgnoreButtonSelector: ".checkout__button"}

window.GIFTBOX_CUSTOM_CART_ITEMS_SELECTORS = [".cart__items__row"]

window.GIFTBOX_CUSTOM_CART_REMOVE_LINK_SELECTORS= ['.cart__items__title > p > a']

window.GIFTBOX_CUSTOM_CART_REMOVE_INPUTS_SELECTORS = [".quantity__button"]

window.GIFTBOX_DISABLE_SECTIONS_UPDATE = location.pathname !== '/cart'

const checkInterval = setInterval(function() {
    const giftBoxElement = document.querySelector('#giftbox-root');

    if (giftBoxElement) {
        var iframe = giftBoxElement.querySelector('[data-cy="popup"]');
        if (iframe && iframe.contentDocument) {
            var links = iframe.contentDocument.querySelectorAll('.GiftBox-Card-Description a');

            if (links.length > 0) {
                var userCurrency = window.Shopify.currency.active;

                links.forEach(function(link) {
                    var productPath = new URL(link.href).pathname;

                    if (userCurrency === 'NZD') {
                        link.href = 'https://fjallraven.co.nz' + productPath;
                    } else if (userCurrency === 'AUD') {
                        link.href = 'https://fjallraven.com.au' + productPath;
                    }
                });

                // Stop checking once we have altered the links
                clearInterval(checkInterval);
            }
        }
    }
}, 1000); 







           

